<!-- Copyright (C) 2018 HTC Global Services, Inc. - All Rights Reserved -->

<div #control class="slider-control"></div>